import { CSSProperties, useEffect, useState } from "react";

export const SHOW_IMAGE_PLACEHOLDER = "/noimage.svg";

export interface ShowThumbnailProps {
  src?: string | null;
  alt?: string;
  style?: CSSProperties;
}

export default function ShowThumbnail({
  src,
  alt = "show-image",
  style,
}: ShowThumbnailProps) {
  const [imgSrc, setImgSrc] = useState(src || SHOW_IMAGE_PLACEHOLDER);

  useEffect(() => {
    setImgSrc(src || SHOW_IMAGE_PLACEHOLDER);
  }, [src]);

  const handleError = () => {
    setImgSrc((current) =>
      current === SHOW_IMAGE_PLACEHOLDER ? current : SHOW_IMAGE_PLACEHOLDER,
    );
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      style={{ objectFit: "cover", ...style }}
      onError={handleError}
    />
  );
}
